import { render, staticRenderFns } from "./DeckBuilderPreview.vue?vue&type=template&id=a5fea82c&"
import script from "./DeckBuilderPreview.vue?vue&type=script&lang=js&"
export * from "./DeckBuilderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports